import { MailOutlined, UserOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { placeholderField, requiredField } from '@client/utils/form.util';
import { flexLayout } from '@client/utils/layout.util';

const { TextArea } = Input;

interface ITenantInfoProps {
  disabled?: boolean;
}

export const TenantInfo: React.FC<ITenantInfoProps> = (props) => {
  const { disabled } = props;
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={[48, 24]}>
        <Col {...flexLayout.halfColumn}>
          <Form.Item
            label={t('tenant.name')}
            name={'name'}
            help={t('tenant.api.name.helper')}
            rules={[requiredField(t('tenant.name'))]}
          >
            <Input
              type={'text'}
              prefix={<UserOutlined />}
              placeholder={placeholderField(t('tenant.name'))}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col {...flexLayout.halfColumn}>
          <Form.Item
            name="email"
            label={t('form.email')}
            rules={[
              requiredField(t('form.email')),
              {
                type: 'email',
                message: t('error.validEmail'),
              },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>
        </Col>
        <Col {...flexLayout.fullColumn}>
          <Form.Item label={t('tenant.description')} name={'description'}>
            <TextArea
              showCount
              maxLength={300}
              rows={4}
              disabled={disabled}
              style={{ resize: 'none' }}
              placeholder={placeholderField(t('tenant.description'))}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
